import {
  WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX,
  isSessionMetadataQueryParamsKey,
} from '../../../../../../constants/integrations/webhookData';

const isDynamicFormCta = cta => cta?.actionData?.actionType === 'dynamicForm';

const hasWebhookIntegration = cta =>
  isDynamicFormCta(cta) && Boolean(cta?.actionData?.integrationId);

export { isDynamicFormCta };

export const collectDynamicFormCtas = ({ campaignData, pollCtaMapping, allCtas }) => {
  const seen = new Set();
  const ctas = [];

  const addCta = cta => {
    if (!cta?._id || seen.has(cta._id) || !isDynamicFormCta(cta)) {
      return;
    }
    seen.add(cta._id);
    ctas.push(cta);
  };

  const resolveCta = actionId => {
    if (!actionId) return null;
    if (typeof actionId === 'object') return actionId;
    return allCtas?.find(cta => cta._id === actionId) || null;
  };

  (campaignData?.actions || []).forEach(addCta);

  const ptConfig = campaignData?.personalizationTool?.ctasConfig;
  addCta(ptConfig?.userInputCTAId);
  addCta(ptConfig?.registrationCTAId);
  addCta(campaignData?.emailCollectionScreen);

  (campaignData?.linkedIntents || []).forEach(intent => {
    addCta(resolveCta(intent?.actionId));
  });

  (pollCtaMapping?.mappedOptions || []).forEach(option => {
    addCta(option?.actionIds?.[0]);
  });

  (pollCtaMapping?.ABtestActions || []).forEach(addCta);

  return ctas;
};

export const isWebhookIntegrationEnabled = (campaignData, pollCtaMapping = {}, allCtas = []) =>
  collectDynamicFormCtas({ campaignData, pollCtaMapping, allCtas }).some(hasWebhookIntegration);

const hasEmptyFieldEntry = entry => {
  const { type, key, actionId, actionFieldId } = entry?.fieldData || {};

  if (!type) {
    return true;
  }

  if (type === 'static') {
    return false;
  }

  if (type === 'other_cta') {
    return !actionId || !actionFieldId;
  }

  if (type === 'sessionMetadata' || type === 'actionTakeData') {
    if (!key) return true;
    if (
      isSessionMetadataQueryParamsKey(key) &&
      (key === WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX ||
        key === `${WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX}.`)
    ) {
      return true;
    }
    return false;
  }

  return false;
};

export const hasEmptyWebhookFieldConfig = ctaWebhookIntegrationConfig => {
  if (!Array.isArray(ctaWebhookIntegrationConfig) || ctaWebhookIntegrationConfig.length === 0) {
    return true;
  }

  return ctaWebhookIntegrationConfig.some(item => {
    const webhookConfig = item?.webhookConfig;

    if (!item?.actionId || !Array.isArray(webhookConfig) || webhookConfig.length === 0) {
      return true;
    }

    return webhookConfig.some(hasEmptyFieldEntry);
  });
};
